export default {
  setLoading: (state, loading) => state.loading = loading,
  setUser: (state, user) => state.user = user
}
